import { render, staticRenderFns } from "./purchaseBilling.vue?vue&type=template&id=538b2856&scoped=true&"
import script from "./purchaseBilling.vue?vue&type=script&lang=js&"
export * from "./purchaseBilling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538b2856",
  null
  
)

export default component.exports